<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="700px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-form-item label="年检设备" prop="DeviceItemNameJson">
            <div style="width: 100%; display: flex; align-items: center">
              <el-input
                v-model="form.DeviceItemNameJson"
                placeholder="请选择设备"
                disabled
                style="width: calc(100% - 60px)"
              ></el-input>
              <el-button style="width: 60px" type="primary" @click="openDevice"
                ><i class="el-icon-search"></i
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item label="年检公司" prop="AnnualInspectionCompany">
            <el-input
              v-model="form.AnnualInspectionCompany"
              placeholder="请输入年检公司"
              disabled
              style="width: calc(100% - 60px)"
            ></el-input>
            <el-button style="width: 60px" type="primary" @click="openSupplier"
              ><i class="el-icon-search"></i
            ></el-button>
          </el-form-item>

          <el-form-item label="年检日期" prop="AnnualInspectionDate">
            <el-date-picker
              v-model="form.AnnualInspectionDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期起始日" prop="sDate">
            <el-date-picker
              v-model="form.sDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期终止日" prop="eDate">
            <el-date-picker
              v-model="form.eDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="年检合格证"
            prop="CertificateConformityUrl"
            class="Describe"
          >
            <el-upload
              class="avatar-uploader"
              :action="
                $rootUrl +
                `/Base_Manage/Upload/ProjectOssUploadFileByForm?Type=3&DeviceType=${form.DeviceType}`
              "
              :headers="{
                Authorization: token,
              }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="form.CertificateConformityUrl"
                fit="contain"
                class="HeadImg"
                :src="form.CertificateConformityUrl"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="年检详情" prop="Remark">
            <el-input
              v-model="form.Remark"
              placeholder=""
              type="textarea"
              rows="3"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
    <DevDialog
      ref="DevDialog"
      @select="handleDevSelect"
      type="radio"
    ></DevDialog>
    <Supplier
      ref="Supplier"
      @select="handleSupplierSelect"
      type="radio"
    ></Supplier>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import Supplier from '@/components/Supplier/Supplier'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      title: '',
      disabled: false,
      moment,
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      State: null,
      row: {},
      form: {
        DeviceItemNameJson: '',
        AnnualInspectionDate: '',
        DeviceId: '',
        device_name: '',
        DeviceCode: '',
        DeviceType: '',
        Remark: '',
        sDate: '',
        eDate: '',
        CertificateConformityUrl: '',
        AnnualInspectionCompany: '',
      },
      Imgs: [],
      rules: {
        DeviceItemNameJson: [
          { required: true, message: '请选择设备', trigger: 'change' },
        ],
        State: [{ required: true, message: '请选择类型', trigger: 'change' }],
        AnnualInspectionDate: [
          { required: true, message: '请选择年检日期', trigger: 'change' },
        ],
        sDate: [
          {
            required: true,
            message: '请选择年检有效期起始日',
            trigger: 'change',
          },
        ],
        eDate: [
          {
            required: true,
            message: '请选择年检有效期终止日',
            trigger: 'change',
          },
        ],
        CertificateConformityUrl: [
          { required: true, message: '请上传年检合格证', trigger: 'change' },
        ],

        AnnualInspectionCompany: [
          { required: true, message: '请输入年检公司', trigger: 'blur' },
        ],
      },
      drawer: false,
    }
  },
  props: {},
  components: { DevDialog, Supplier },
  methods: {
    handlePictureCardPreview(file) {
      window.open(file.url)
    },
    handleDevSelect(arr) {
      console.log(arr)
      this.$set(this.form, 'DeviceId', arr[0].Id)
      this.$set(this.form, 'device_name', arr[0].device_name)
      this.$set(this.form, 'DeviceCode', arr[0].DeviceCode)
      this.$set(this.form, 'DeviceType', arr[0].DeviceType)
      this.$set(
        this.form,
        'DeviceItemNameJson',
        `${this.form.device_name}(${this.form.DeviceCode})`
      )
    },
    handleSupplierSelect(arr) {
      console.log(arr)
      this.$set(this.form, 'AnnualInspectionCompanyId', arr[0].Id)
      this.$set(this.form, 'AnnualInspectionCompany', arr[0].Name)
    },
    openDevice() {
      this.$refs.DevDialog.openDialog()
    },
    openSupplier() {
      this.$refs.Supplier.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(file, fileList)
      console.log(res, 'res')
      if (res.code == '200') {
        this.form.CertificateConformityUrl = res.url
      } else {
        this.$notify.error(res.Msg)
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.Imgs = [...fileList]

      // this.Imgs = [...fileList];
    },

    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }

        this.loading = true

        this.$http
          .post('/Base_DeviceTreeManage/Device_AnnualInspection/SaveData', {
            ...this.form,
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.row = row
      this.form = {
        DeviceItemNameJson: '',
        AnnualInspectionDate: '',
        DeviceId: '',
        device_name: '',
        DeviceCode: '',
        DeviceType: '',
        Remark: '',
        sDate: '',
        eDate: '',
        CertificateConformityUrl: '',
        AnnualInspectionCompany: '',
      }

      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_AnnualInspection/GetTheData', {
          id: id,
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data || {}
            this.$set(
              this.form,
              'DeviceItemNameJson',
              `${this.form.device_name}(${this.form.DeviceCode})`
            )
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
